export const locale = {
    lang: 'en',
    data: {
        "PAGES": {
            "HOME": {
                "TITLE": "Home"
            },
            "AUTHENTICATION": {
                "LOGIN": {
                    "INTRO": {
                        "TITLE": "Welcome to SiGE",
                        "DESCRIPTION": "Colegio Secundario Gral. Manuel Belgrano"
                    },
                    "FORM": {
                        "TITLE": "Login to your account",
                        "DESCRIPTION": "Enter username and password"
                    }
                }
            },
            "MANAGEMENT": {
                "GROUP_NAME": "Management",
                "USERS": "Users",
                "STUDENTS": "Students",
                "EMPLOYEES": "Staff",
                "SUBJECTS": "Subjects",
                "CURRICULA": "Curricula",
                "SCHOOL_YEARS": "School Years",
                "SCHOOL_SCHEDULE": "School Schedule",
                "DIVISIONS": "Divisions",
                "PROFESSIONAL_CONCEPT": "Professional Concept",
                "DIVISION_SCHEDULE": "Division Schedule",
                "TEACHERS": "Teachers",
                "SCHOOLDATA": "School data",
                "NEWS": "NEWS",
                "EXAM_CALLS": "Exam calls"
            },
            "SECURITY": {
                "GROUP_NAME": "Security",
                "ROLESANDPERMISSIONS": "Roles and permissions"
            },
            "NEWS": {
                "GROUP_NAME": "News",
                "NEWS": "News Admin"
            },
            "CONFIGURATION": {
                "GROUP_NAME": "Configuration",
                "DIVISION_COLOR_CONFIG": "Divisions Configuration",
                "INDEX_CARD_CONFIGURATION": "Index Card Configuration",
            }
        },
        "FIELDS": {
            "ID": "ID",
            "ALIAS": "Alias",
            "USERNAME": "User Name",
            "PASSWORD": "Password",
            "CONFIRM_PASSWORD": "Confirm password",
            "EMAIL": "Email",
            "EMAIL_ALUMNO": "Student Email",
            "EMAIL_TUTOR": "Tutor Email",
            "FIRST_NAME": "First Name",
            "FIRST_NAME_ALUMNO": "Student First Name",
            "FIRST_NAME_TUTOR": "Tutor First Name",
            "LAST_NAME": "Last Name",
            "LAST_NAME_ALUMNO": "Student Last Name",
            "LAST_NAME_TUTOR": "Tutor Last Name",
            "OBSERVATIONS": "Observations",
            "RECEPIT_NUMBER": "Receipt Number",
            "SUBJECT_NAME": "Name",
            "NEW_TITULO": "Titulo",
            "NEW_RESUMEN": "Resumen",
            "NEW_TEXTO": "Text",
            "NEW_TIPO": "Tipo",
            "SUBJECT_DESCRIPTION": "Description",
            "CURRICULUM_DESCRIPTION": "Description",
            "PHONE_NUMBER": "Phone number",
            "POSTTITLE": "Post title",
            "HIRE_DATE": "Hiring Date at School",
            "DATE": "Date",
            "AMOUNT": "Amount",
            "ATTENDANCE_DATE": "Start Date",
            "TEACHING_START_DATE": "Teaching Start Date",
            "OTHER_TRAININGS": "Other Trainings",
            "POST_GRADUATE_COURSE": "Post Graduate Course",
            "MOBILE_PHONE_NUMBER": "Mobile phone number",
            "ANOTHER_CONTACT_PHONE": "Another contact phone",
            "ANOTHER_PHONE_BELONGS": "Another phone belongs",
            "FILTER_USERS": "Filter users",
            "FILTER_ORDERS": "Filter orders",
            "FILTER_STUDENTS": "Filter students",
            "FILTER_SCHOOL_YEARS": "Filter School Years",
            "FILTER_SCHOOL_SCHEDULE": "Filter schoool schedule",
            "FILTER_SUBJECTS": "Filter subjects",
            "FILTER_NEWS": "Filter news",
            "FILTER_CURRICULUM": "Filter curriculum",
            "FILTER_TEACHERS": "Filter teachers",
            "RECORDS_PER_PAGE": "Records per page",
            "OF": "of",
            "PREVIOUS": "Previous",
            "NEXT": "Next",
            "CHECK_ALL": "Check all",
            "UNCHECK_ALL": "Uncheck all",
            "NAME": "Name",
            "DESCRIPTION": "Description",
            "DOCUMENT_NUMBER": "Document number",
            "DOCUMENT_NUMBER_ALUMNO": "Student Document number",
            "DOCUMENT_NUMBER_TUTOR": "Tutor Document number",
            "CUIL": "CUIL",
            "CUIL_ALUMNO": "Student CUIL",
            "CUIL_TUTOR": "Tutor CUIL",
            "YEAR_NAME": "Year",
            "DIVISION_NAME": "Division name",
            "GENDER": "Gender",
            "GENDER_ALUMNO": "Student Gender",
            "GENDER_TUTOR": "Tutor Gender",
            "AGE": "Age",
            "ADDRESS": "Address",
            "BIRTHDATE": "Birthdate",
            "BIRTHDATE_ALUMNO": "Student Birthdate",
            "BIRTHDATE_TUTOR": "Tutor Birthdate",
            "START_DATE": "Start Date",
            "FINISH_DATE": "Finish Date",
            "START": "Start",
            "FINISH": "Finish",
            "TYPE_SCHOOL_SCHEDULE": "Type School Schedule",
            "NEW_PASSWORD": "New password",
            "CONFIRM_NEW_PASSWORD": "Confirm new password",
            "PHOTO": "Photo",
            "ACTIONS": "Actions",
            "HEIGHT": "Height",
            "WEIGHT": "Weight",
            "STATUS": "Status",
            "FIELD": "This fields",
            "ORIGIN": "Origin",
            "WIDTH": "Width",
            "COUNT": "Count",
            "COURSE_LIST": "Course List",
            "CONCEPT": "Concept",
            "SHIFT": "Shift",
            "RELATIONSHIP": "Relationship with the student",
            "MLRELATIONSHIP": "Relationship",
            "CURRICULUM": "Curriculum",
            "EVENT_TYPE": "Event Type",
            "TYPE_EMPLOYEE": "Type Employee",
            "COURSE": "Course",
            "JOB_TITLE": "Job Title",
            "JOB_TITLES": "Job Titles",
            "SUBJECT": "Subject",
            "FEMALE": "Female",
            "MALE": "Male",
            "HAS_BROTHERS_SCHOOL_AGE": "Has a school-age brother",
            "REPEAT_STUDENT": "Is student",
            "BELONGS_ETHNIC_GROUP": "Belongs Ethnic Group?",
            "BELONGS_RURAL_COMMUNITY": "Belongs Rural Comunity?",
            "ETHNIC_NAME": "Ethnic Name",
            "FILE_NUMBER": "File Number",
            "LIBRO": "Libro",
            "FOLIO": "Folio",
            "HAS_PROGRESAR_PLAN": "¿Has Progresar Plan?",
            "HAS_GOVERNMENT_PC": "¿Has government pc?",
            "HAS_PENDING_SUBJECTS": "¿Has pendings subjects?",
            "PENDINGS_SUJECTS": "Pendings subjects",
            "HAS_INTERNET": "Has Internet?",
            "RURAL_COMMUNITY": "Rural Community",
            "HAS_HEALTH_PROBLEMS": "Has health problems?",
            "DESCRIPTION_HEALTH_PROBLEMS": "Describe health problems",
            "HAS_LEGAL_PROBLEMS": "¿Has legal problems?",
            "DESCRIPTION_LEGAL_PROBLEMS": "Describe legal problems",
            "YEAR": "Year",
            "TITLE": "Title",
            "SCHOOL_NUMBER": "Number",
            "SCHOOL_NAME": "Name",
            "MAIL": "Mail",
            "SCHOOL_ADDRESS": "Address",
            "SCHOOL_PHONE_NUMBER": "Phone number",
            "SCHOOL_ENTRY_TIME": "Entry time",
            "SCHOOL_DEPARTURE_TIME": "Departure tme",
            "VICE_DIRECTOR": "Vice director",
            "DIRECTOR": "Director",
            "MARGIN_TOP": "Margin Top",
            "MARGIN_BOTTOM": "Margin Bottom",
            "MARGIN_LEFT": "Margin Left",
            "MARGIN_RIGHT": "Margin Right",
            "ROW_HEIGHT": "Row Height",
            "FILTER_EMPLOYEE": "Filter Employee",
            "SET_UP": "Set Up",
            "ATTRIBUTES": "Attributes",
            "EMAILS_LIST": "Email List",
            "PERSONAL_DATA": "Personal Data",
            "PERSONAL_DATA_CONT": "Personal Data (Cont.)",
            "PENDINGS_SUBJECTS": "Pending Subjects",
            "CONTACT": "Contact",
            "TUTOR": "Tutor",
            "TUTOR_CONT": "Tutor (Cont.)",
            "DOCUMENTATION": "Documentation",
            "PAYMENTS": "Contribution Bonus",
            "ADD_PENDING_SUBJECT": "Add Pending Subject",
            "ADD_PAYMENTS": "Add Pay",
            "ADMISSION": "Admission",
            "TITLES": "Títles",
            "WORKLOAD": "Workload",
            "HOURS": "Hours",
            "NATIONALITY": "Nationality",
            "LOCATION": "Location",
            "OCUPATION": "Ocupation",
            "SCHOOL_ORIGIN": "School of origin",
            "PAYMENT": "Payment",
            "EXAM_CALL_TYPE": "Type",
            "EXAM_CALL_DESCRIPTION": "Description",
            "FILTER_EXAM_CALLS": "Filter exam calls",
            "SUBJECTS": "Subjects",
            "SELECT_EXAM_CALLS": "Select exam calls",
            "MONTH": "Month",
            "CALL_NUMBER": "Call number"
        },

        "VALIDATIONS": {
            "REQUIRED": "{{value}} is required",
            "REQUIRED_OR_ERROR": "{{value}} is required or format is incorrect",
            "EMAIL": "Please enter a valid email",
            "PASSWORD": "The password must contain at least 6 characters, 1 upper case letter, 1 lowercase letter, 1 number and 1 alphanumeric character.",
            "PASSWORD_MIN": "The password must contain at least 6 characters.",
            "PASSWORDS_MISMATCH": "The passwords mismatch"
        },
        "ERRORS": {
            "INCORRECT_USERNAME_OR_PASSWORD": "Incorrect user name or password",
            "HTTP_STATUS_CODES": {
                "401": {
                    "MESSAGE": "Restricted access. You need to be authenticated to perform this action.",
                    "GOBACK": "Go to login"
                },
                "403": {
                    "MESSAGE": "You do not have sufficient permissions to perform this action.",
                    "GOBACK": "Go back to home"
                },
                "404": {
                    "MESSAGE": "Sorry but we could not find the page you are looking for.",
                    "GOBACK": "Go back to home"
                },
                "500": {
                    "MESSAGE": "Looks like we have an internal issue, please try again in couple minutes.",
                    "GOBACK": "Go back to home"
                }
            },
            "ERROR_REQUEST": "An error occurred processing the request. Detail: {{value}}",
            "MAXIMUM_SIZE_EXCEEDED": "The maximum file size is {{value}}"
        },
        "BUTTONS": {
            "GOBACK": "Go back",
            "LOGIN": "Login",
            "LOGOUT": "Logout",
            "MY_PROFILE": "My Profile",
            "ADD_USER": "Add User",
            "ADD_ORDER": "Add Order",
            "ADD_ROLE": "Add Role",
            "REMOVE_ROLE": "Remove Role",
            "SAVE": "Save",
            "SAVE_AND_EXIT": "Save and exit",
            "SAVE_CHANGES": "Save Changes",
            "CLOSE": "Close",
            "CANCEL": "Cancel",
            "VIEW": "View",
            "EDIT": "Edit",
            "CHANGE_COURSE": "Change shift",
            "DELETE": "Delete",
            "MEDICAL_LETTER_REQUEST": "Medical Letter Request",
            "CHANGE_PASSWORD": "Change password",
            "ADD_STUDENT": "Add Student",
            "ADD_EMPLOYEE": "Add Employee",
            "ADD_SUBJECT": "Add Subject",
            "ADD_NEWS": "Add New",
            "NEW_TITLE": "Titulo",
            "NEW_RESUMEN": "Resumen",
            "EDIT_NEWS": "Edit New",
            "VIEW_NEWS": "View New",
            "ADD_YEAR": "Add Year",
            "ADD_CURRICULUM": "Add Curriculum",
            "ADD_DIVISION": "Add Division",
            "ADD_SCHOOL_SCHEDULE": "Add School Schedule",
            "ADD_SCHOOL_YEAR": "Add School Year",
            "ADD_SCHEDULE": "Add Schedule",
            "PRINT_STUDENTLIST": "Student List",
            "PRINT": "Print",
            "PRINT_ALL": "Print All",
            "PRINT_REPORTCARD": "Report Card",
            "ADD_TEACHER": "Add Teacher",
            "ADD_TUTOR": "Add Tutor",
            "EDIT_STUDENT": "Edit Student",
            "EDIT_EMPLOYE": "Edit_Employe",
            "EDIT_SUBJECT": "Edit Subject",
            "EDIT_DIVISION": "Edit Division",
            "EDIT_SCHOOL_SCHEDULE": "Edit School Schedule",
            "EDIT_TEACHER": "Edit Teacher",
            "ASSIGN_TEACHER": "Assign Teacher",
            "EDIT_TUTOR": "Edit Tutor",
            "EDIT_YEAR": "Edit Year",
            "VIEW_STUDENT": "View Student",
            "VIEW_EMPLOYEE": "View Employee",
            "VIEW_SUBJECT": "View Subject",
            "VIEW_TEACHER": "View Teacher",
            "VIEW_SCHOOL_SCHEDULE": "View School Schedule",
            "VIEW_TUTOR": "View Tutor",
            "VIEW_DIVISION": "View Division",
            "VIEW_YEAR": "View Year",
            "DETAIL": "Detail",
            "ADD": "Add",
            "ACCEPT": "Accept",
            "REFRESH": "Refresh",
            "INDEX_CARD_CONFIGURATION": "Index Card Configuration. (Values en mm)",
            "TEACHING_ASSISTANCE": "Teaching Assistance",
            "PRINT_INDEX_CARD": "Print Index Card",
            "EXPORT_TO_EXCEL": "Export to Excel",
            "RECEIPTS_TO_EXCEL": "Export Receipts",
            "EMAILS": "Emails",
            "EXPORT": "Export",
            "CONSULT": "Consult",
            "COPY": "Copy",
            "ADD_JOB_TITLE": "Add Job Title",
            "BONUS": "Bonus",
            "ADD_PAYMENT": "Add payment",
            "VIEW_HISTORY": "View history",
            "ADD_NEW": "Add News",
            "ADD_EXAM_BOARD": "Add exam board",
            "DOWNLOAD": "Download"
        },
        "TABLES": {
            "NOFOUND": "No records found matching filter"
        },
        "LANGUAGES": {
            "ENGLISH": "English",
            "SPANISH": "Spanish",
        },
        "PERMISSIONS": {
            "PAGES_HOME": "Home",
            "PAGES_MANAGEMENT": "Management",
            "PAGES_MANAGEMENT_USERS": "Management > Users",
            "PAGES_MANAGEMENT_USERS_ADD": "Management > Users > Add",
            "PAGES_MANAGEMENT_USERS_EDIT": "Management > Users > Edit",
            "PAGES_MANAGEMENT_USERS_REMOVE": "Management > Users > Remove",
            "PAGES_MANAGEMENT_USERS_VIEW": "Management > Users > View",
            "PAGES_MANAGEMENT_USERS_CHANGEPASSWORD": "Management > Users > Change Password",

            "PAGES_MANAGEMENT_STUDENTS": "Management > Students",
            "PAGES_MANAGEMENT_STUDENTS_ADD": "Management > Students > Add",
            "PAGES_MANAGEMENT_STUDENTS_EDIT": "Management > Students > Edit",
            "PAGES_MANAGEMENT_STUDENTS_REMOVE": "Management > Students > Remove",
            "PAGES_MANAGEMENT_STUDENTS_DETAIL": "Management > Students > Detail",
            "PAGES_MANAGEMENT_STUDENTS_EXPORT": "Management > Students > Export to Excel",
            "PAGES_MANAGEMENT_STUDENTS_EXPORT_RECEIPTS": "Management > Students > Export Receits to Excel",
            "PAGES_MANAGEMENT_STUDENTS_CHANGE_COURSE": "Management > Students > Change Course",
            "PAGES_MANAGEMENT_STUDENTS_VIEW_PAYMENT": "Management > Students > View Payment",

            "PAGES_MANAGEMENT_TEACHERS": "Management > Teachers",
            "PAGES_MANAGEMENT_TEACHERS_ADD": "Management > Teachers > Add",
            "PAGES_MANAGEMENT_TEACHERS_EDIT": "Management > Teachers > Edit",
            "PAGES_MANAGEMENT_TEACHERS_REMOVE": "Management > Teachers > Remove",
            "PAGES_MANAGEMENT_TEACHERS_DETAIL": "Management > Teachers > Detail",

            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE": "Management > School Schedule",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_ADD": "Management > School Schedule > Add",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_EDIT": "Management > School Schedule > Edit",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_REMOVE": "Management > School Schedule > Remove",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_DETAIL": "Management > School Schedule > Detail",

            "PAGES_MANAGEMENT_CURRICULUM": "Management > Curriculum",
            "PAGES_MANAGEMENT_CURRICULUM_ADD": "Management > Curriculum > Add",
            "PAGES_MANAGEMENT_CURRICULUM_EDIT": "Management > Curriculum > Edit",
            "PAGES_MANAGEMENT_CURRICULUM_REMOVE": "Management > Curriculum > Remove",
            "PAGES_MANAGEMENT_CURRICULUM_VIEW": "Management > Curriculum > Detail",

            "PAGES_MANAGEMENT_SUBJECTS": "Management > Subjects",
            "PAGES_MANAGEMENT_SUBJECTS_ADD": "Management > Subjects > Add",
            "PAGES_MANAGEMENT_SUBJECTS_EDIT": "Management > Subjects > Edit",
            "PAGES_MANAGEMENT_SUBJECTS_REMOVE": "Management > Subjects > Remove",
            "PAGES_MANAGEMENT_SUBJECTS_DETAIL": "Management > Subjects > Detail",

            "PAGES_MANAGEMENT_DIVISIONS": "Management > Divisions",
            "PAGES_MANAGEMENT_DIVISIONS_ADD": "Management > Divisions > Add",
            "PAGES_MANAGEMENT_DIVISIONS_EDIT": "Management > Divisions > Edit",
            "PAGES_MANAGEMENT_DIVISIONS_REMOVE": "Management > Divisions > Remove",
            "PAGES_MANAGEMENT_DIVISIONS_DETAIL": "Management > Divisions > Detail",

            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT": "Management > Teacher concept",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT_EDIT": "Management > Teacher concept > Edit",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT_DETAIL": "Management > Teacher concept > View",

            "PAGES_MANAGEMENT_SCHOOL_YEAR": "Management > School year",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_ADD": "Management > School year > Add",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_EDIT": "Management > School year > Edit",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_DELETE": "Management > School year > Remove",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_DETAIL": "Management > School year > Detail",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_ACTIVE": "Management > School year > Active new year",

            "PAGES_MANAGEMENT_EMPLOYEE": "Management > Employee",
            "PAGES_MANAGEMENT_EMPLOYEE_ADD": "Management > Employee > Add",
            "PAGES_MANAGEMENT_EMPLOYEE_EDIT": "Management > Employee > Edit",
            "PAGES_MANAGEMENT_EMPLOYEE_DELETE": "Management > Employee > Remove",
            "PAGES_MANAGEMENT_EMPLOYEE_DETAIL": "Management > Employee > Detail",
            "PAGES_MANAGEMENT_EMPLOYEE_EXPORT_EXCEL": "Management > Employee > Export",
            "PAGES_MANAGEMENT_EMPLOYEE_MEDICAL_LETTER": "Management > Employee > Medical Letter",
            "PAGES_MANAGEMENT_EMPLOYEE_PRINT_FILES": "Management > Employee > Print Card",
            "PAGES_MANAGEMENT_EMPLOYEE_COPY_MAILS": "Management > Employee > Copy Mails",
            "PAGES_MANAGEMENT_EMPLOYEE_PRINT_ASSISTANCE": "Management > Employee > Assistance",
            "PAGES_MANAGEMENT_STUDENTS_PRINT_ALUMNOS": "Administración > Alumnos > Imprimir Listado de Alumnos",
            "PAGES_MANAGEMENT_STUDENTS_PRINT_CALIFICACIONES": "Administración > Alumnos > Imprimir Planilla de Calificaciones",
            "PAGES_MANAGEMENT_NEWS": "Administración > Noticias",
            "PAGES_NEWS": "Noticias",
            "PAGES_MANAGEMENT_NEWS_ADD": "Administración > Noticias > Agregar",
            "PAGES_MANAGEMENT_NEWS_DETAIL": "Administración > Noticias > Ver",
            "PAGES_MANAGEMENT_NEWS_EDIT": "Administración > Noticias > Editar",
            "PAGES_MANAGEMENT_NEWS_REMOVE": "Administración > Noticias > Eliminar",

            "PAGES_MANAGEMENT_SCHOOLDATA": "Management > School data",
            "PAGES_MANAGEMENT_SCHOOLDATA_EDIT": "Management > School data > Edit",

            "PAGES_SECURITY": "Security",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS": "Security > Roles And Permissions",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_ADD": "Security > Roles And Permissions > Add",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_EDIT": "Security > Roles And Permissions > Edit",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_REMOVE": "Security > Roles And Permissions > Remove",

            "PAGES_MANAGEMENT_EMPLOYEES": "Administración > Empleados",
            "PAGES_MANAGEMENT_EMPLOYEES_ADD": "Administración > Empleados > Agregar",
            "PAGES_MANAGEMENT_EMPLOYEES_EDIT": "Administración > Empleados > Editar",
            "PAGES_MANAGEMENT_EMPLOYEES_REMOVE": "Administración > Empleados > Eliminar",
            "PAGES_MANAGEMENT_EMPLOYEES_DETAIL": "Administración > Empleados > Detalle",
            "PAGES_MANAGEMENT_EMPLOYEES_EXPORT": "Administración > Empleados > Exportar"
        },
        "MESSAGES": {
            "REPORT_CONFIG_DESCRIPTION": "Configure how you want people names to be displayed in system-generated PDF reports (Teacher Attendance, Grades, and Exam Boards)."
        },
        "LABELS": {
            "SUCCESS": "Success",
            "REPORT_CONFIGURATION": "Report Configuration",
            "PDF_REPORTS_SETTINGS": "PDF Reports Settings",
            "USE_ALIAS_IN_REPORTS": "Use Alias in reports",
            "DELETION_CONFIRMATION_QUESTION": "Are you sure you want to delete \"{{value}}\"?",
            "YES": "Yes",
            "NO": "No",
            "PROMOTED_REPEATER_REENROLLED": "Promoted / Repeater / Re-enrolled ",
            "REENROLLED": "RE-ENROLLED",
            "REPEATER": "Repeater",
            "PROMOTED": "Promoted",
            "CONFIRMATION": "Confirmation",
            "DELETED_CORRECTLY": "The item was deleted correctly",
            "SUCCESS_REQUEST": "Correctly processed request",
            "CHANGES_SAVED_CORRECTLY": "Changes saved correctly",
            "SAVING_CHANGES": "Saving changes...",
            "CORRECTLY_ADDED": "{{value}} added correctly",
            "CORRECTLY_MODIFIED": "Correctly modified {{value}}",
            "CORRECTLY_MODIFIED_FEMALE": "Correctly modified {{value}}",
            "CORRECTLY_DELETED": "{{value}} deleted correctly",
            "CORRECTLY_UPLOADED": "{{value}} uploaded correctly",
            "CORRECTLY_UPLOADED_FEMALE": "{{value}} uploaded correctly",
            "ROLE": "Role",
            "USER": "User",
            "PERMISSION": "Permission",
            "LOADING": "Loading...",
            "LOADING_VALUE": "Loading {{value}}...",
            "SEARCH": "Search",
            "STUDENT": "Student",
            "TEACHER": "Teacher",
            "PERSON": "Personal",
            "NEW": "New",
            "Menu": "Menu",
            "MEDICALLETTER": "Medical Letter",
            "PRINT_LIST_OF": "List of",
            "PRINT_LIST_REPORT_STUDENT": "Report",
            "PRINT_CARD": "Card",
            "PRINT_STUDENTS": "Students",
            "EDIT_DIVISION": "Edit",
            "DELETE_DIVISION": "Delete",
            "DIVISION_SCHEDULE": "Schedule",
            "DIVISION_SCHEDULE_ALL": "Print all schedules",
            "TEACHER_ALL": "Download List of Teachers",
            "DIVISION_TEACHERS": "Teachers",
            "HEADER_CURRICULUM": "Curriculum Data",
            "HEADER_SCHOOL_YEAR": "School Year Data",
            "PROFESSIONAL_CONCEPT": "Professional Concept",
            "DIVISIONS_BY_SHIFT": "Division by Shift",
            "Staff": "Staff",
            "SUBJECTS_BY_YEAR": "Subjects by Year",
            "YEAR": "Year",
            "DIVISION": "Division",
            "STUDENTS": "Students",
            "HEADER_SCHOOL_DATA": "School Data",
            "SHIFTS": "Shifts",
            "DATA_SAVED_CORRECTLY": "Data saved correctly",
            "MANUALLY_DATA": "Manual data",
            "COURSES": "Courses",
            "PAYMENT": "Payment",
            "TOTAL_AMOUNT": "Total (selected)",
            "HISTORY": "Registration history"
        },
        "EXAM_CALL_TYPES": {
            "REGULAR": "Regular",
            "COMPLETE": "Complete career",
            "PENDING": "Pending"
        },
        "MONTHS": {
            "JANUARY": "January",
            "FEBRUARY": "February",
            "MARCH": "March",
            "APRIL": "April",
            "MAY": "May",
            "JUNE": "June",
            "JULY": "July",
            "AUGUST": "August",
            "SEPTEMBER": "September",
            "OCTOBER": "October",
            "NOVEMBER": "November",
            "DECEMBER": "December"
        },
        "CALL_NUMBERS": {
            "FIRST": "First call",
            "SECOND": "Second call",
            "THIRD": "Third call",
            "FOURTH": "Fourth call",
            "FIFTH": "Fifth call",
            "SIXTH": "Sixth call",
            "SEVENTH": "Seventh call",
            "EIGHTH": "Eighth call",
            "NINTH": "Ninth call",
            "TENTH": "Tenth call"
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/main/i18n/en.ts